import React, { Fragment, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Grid } from "@material-ui/core";
import { AccountBalance, Add, Assignment, Receipt } from "@material-ui/icons";

import { GenericStepperForm } from "../../atomic/organisms/GenericStepper";
import { AsientosContablesSelect } from "../UI/AsientosContablesSelect";
import { DocumentacionComprobante } from "../UI/Documentacion/DocumentacionComprobante";
import { TramiteComprobanteForm } from "../MesaEntradaRecepcion/Form/TramiteComprobanteForm";
import { PrestadoresForm } from "../MesaEntradaRecepcion/Form/TipoComprobante/PrestadoresForm";
import { useMesaEntrada } from "../../../hooks/useCases/useMesaEntrada";
import { ESTADOS_COMRPOBANTES, TIPO_EFECTORES } from "../../../utils/constants";
import { ValidatorInputField } from "../../atomic/atoms/Inputs";
import { getDocumentacionComprobante } from "../../../actions/mesaEntrada/documentacionMesaEntradaActions";

export const StepperOspeDirecto = ({ comprobante, onClose, ...form }) => {
    const { put, clean } = useMesaEntrada();
    const { cuentas } = useSelector((state) => state.contratacionesDatosBancarios);
    const dispatch = useDispatch()
    const [restoCuenta, setRestoCuenta] = useState(0);
    return (
        <GenericStepperForm
            size="md"
            onClose={() => onClose()}
            steps={[
                {
                    stepLabel: "Tramite Comprobante",
                    Component: <TramiteComprobanteForm ospeDirecto {...{ formValues: comprobante, ...form }} />,
                },
                {
                    stepLabel: "Datos Comprobante",
                    Component: (
                        <Fragment>
                            <Grid container spacing={2}>
                                <PrestadoresForm ospeDirecto {...{ formValues: comprobante, setearVariosValores: form.setFormValues, ...form }} />
                            </Grid>
                            <Grid item xs={12}>
                                <ValidatorInputField
                                    variant="outlined"
                                    label="Observaciones"
                                    name="observaciones"
                                    value={comprobante?.observaciones ?? ""}
                                    onChange={form.handleInputChange}
                                    multiline
                                    rows={5}
                                    disabled
                                />
                            </Grid>
                        </Fragment>
                    ),
                    handleClickNext: (handleNext) => {
                        dispatch(getDocumentacionComprobante(comprobante.id, true))
                        handleNext()
                    }
                },
                ...(comprobante?.idTipoEfector === TIPO_EFECTORES.PROVEEDOR && cuentas.length > 1 ? [{
                    stepLabel: "Asignación Cuentas Contables",
                    Component: <AsientosContablesSelect {...{ restoCuenta, setRestoCuenta, formValues: comprobante, setearVariosValores: form.setFormValues, ...form }} />,
                    disabledNext: !(+restoCuenta === 0)
                }] : []),
                {
                    stepLabel: "Documentación Comprobante",
                    Component: <DocumentacionComprobante menuPrestadorRecepcion idExpediente={comprobante?.id} ospeDirecto disabled />,
                },
            ]}
            stepIcons={comprobante?.idTipoEfector === TIPO_EFECTORES.PROVEEDOR && cuentas.length > 1 ? {
                1: <Receipt />,
                2: <Add />,
                3: <AccountBalance />,
                4: <Assignment />,
            } : {
                1: <Receipt />,
                2: <Add />,
                3: <Assignment />,
            }}
            buttonLabelFinish="Confirmar"
            handleSubmit={() => {
                put.comprobanteOspeDirecto({
                    ...comprobante,
                    idEstado: ESTADOS_COMRPOBANTES.ENVIADA,
                    idTramite: comprobante?.tramite?.id,
                    idTipoExpediente: comprobante?.tipoExpediente?.id,
                    idEfectorFacturacion: comprobante?.efectorFacturacion?.idEfectorFacturacion,
                    idTipoEfector: comprobante?.efectorFacturacion?.idTipoEfector,
                    idUsuarioOspeDirecto: comprobante?.userAlta?.id
                });
                clean.cuentasContables();
                onClose();
            }}
        />
    );
};
